export default __webpack_public_path__ + "static/media/bg-chat-tile-light.7fff1c4f.png";